export function downloadCSV(accountSummary: (AccountSummaryDetail | null)[]) {
  const headersMapping = [
    { field: 'accountBusinessName', header: 'Account Business Name' },
    { field: 'utilityCompany', header: 'Utility Company' },
    { field: 'utilityAccountNumber', header: 'Utility Account Number' },
    { field: 'serviceAddress', header: 'Service Address' },
    { field: 'associatedSolarFarm', header: 'Solar Farm' },
    {
      field: 'annualizedUsageEstimate',
      header: 'Annualized Usage Estimate (kWh)',
    },
    {
      field: 'planName',
      header: 'Plan Name',
    },
    { field: 'vnmSubscriptionStatus', header: 'VNM Subscription Status' },
    {
      field: 'commercialOperationDate',
      header:
        'Expected Project Launch Date Expect Credits 3 Months+ After This Date',
    },
    { field: 'rateClass', header: 'Rate Class' },
    { field: 'discountPercentage', header: 'Discount Percentage' },
    { field: 'paymentSummary', header: 'Payment Summary' },
  ];

  const csvData = convertJSONToCSV(accountSummary, headersMapping);
  const today = new Date().toJSON().slice(0, 10).replace(/-/g, '_');
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', `account_summary_${today}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function convertJSONToCSV(jsonData, headersMapping) {
  /* eslint-disable prefer-template */
  const headers = headersMapping.map(h => h.header).join(',') + '\n';
  if (jsonData.length === 0) {
    return headers;
  }
  /* eslint-enable prefer-template */
  const rows = jsonData
    .map(row => {
      return headersMapping
        .map(h => `"${String(row?.[h.field] || '').replace(/"/g, '""')}"`)
        .join(',');
    })
    .join('\n');

  return headers + rows;
}
